<mat-toolbar class="content-header">
    <mat-icon class="header-icon" fontIcon="wifi"></mat-icon>
    <h1 class="page-title">{{'projects.status' | translate}}</h1>
    <span class="toolbar-spacer"></span>

    <lib-button [matMenuTriggerFor]="submenu" text="{{'projects.filter' | translate}}" icon="filter_list"
        color="secondary"></lib-button>

    <mat-menu #submenu="matMenu">
        <div class="toggle">
            <mat-slide-toggle [(ngModel)]="showProjectWithoutTracker"
                (click)="filter('project')">{{'projects.showProjectWithoutTracker' | translate}}</mat-slide-toggle>
        </div>
        @for(config of configs; track config.name){
        <div class="toggle">
            <mat-slide-toggle [(ngModel)]="config.visible"
                (click)="filter(config.name)">{{config.name}}</mat-slide-toggle>
        </div>
        }
    </mat-menu>
</mat-toolbar>

<div class="project-table">
    <table mat-table [dataSource]="projectsData" matSort>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="worker-column-width">
                <div class="header-content">
                    <mat-icon fontIcon="wifi"></mat-icon>
                </div>
            </th>

            <td mat-cell *matCellDef="let row" class="color-cell">
                <div class="connect">
                    <div class="status-led {{row.status}}"></div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="header-content">
                    <mat-icon fontIcon="source"></mat-icon>
                    {{'datatable.name' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row" class="text-shadow">
                {{row.name}}
            </td>
        </ng-container>


        <ng-container matColumnDef="trackers">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="header-content">
                    <mat-icon fontIcon="devices"></mat-icon>
                    {{'trackers.title' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row">
                <div class="com-status">

                    <div class="chip-list">
                        @for(tracker of row.trackers; track tracker.name) {
                        @if(tracker.visible){
                        <lib-chip color="outline" class="{{tracker.color}}" icon="wifi" [text]="tracker.name">


                            <span class="battery full" *ngIf="tracker.batteryLevel >= 70">
                                <mat-icon fontIcon="battery_full"></mat-icon>
                            </span>

                            <span class="battery half" *ngIf="tracker.batteryLevel < 70 && tracker.batteryLevel >= 40">
                                <img src="/img/icons/indicator/battery_40.svg" alt="Battery Half" class="battery-icon">
                            </span>

                            <span class="battery warning"
                                *ngIf="tracker.batteryLevel < 40 && tracker.batteryLevel >= 10">
                                <img src="/img/icons/indicator/battery_10.svg" alt="Battery Low" class="battery-icon">
                            </span>

                            <span class="battery danger" *ngIf="tracker.batteryLevel < 10 && tracker.batteryLevel >= 0">
                                <img src="/img/icons/indicator/battery_empty.svg" alt="Battery Empty"
                                    class="battery-icon">
                            </span>

                            <span class="battery unknown" *ngIf="tracker.batteryLevel== -1">
                                <mat-icon class="unknown" fontIcon="battery_unknown"></mat-icon>
                            </span>

                            <span class="battery full" *ngIf="tracker.shackleBattery >= 40">
                                <mat-icon svgIcon="shackle_full" class="weight-icon"></mat-icon>
                            </span>

                            <span class="battery warning"
                                *ngIf="tracker.shackleBattery < 40 && tracker.shackleBattery >= 10">
                                <mat-icon svgIcon="shackle_full" class="weight-icon"></mat-icon>
                            </span>
                            <span class="battery danger"
                                *ngIf="tracker.shackleBattery != -1 && tracker.shackleBattery < 10">

                                <mat-icon svgIcon="shackle_full" class="weight-icon"></mat-icon>
                            </span>
                        </lib-chip>
                        }
                        }
                    </div>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="metrics">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="header-content">
                    <mat-icon fontIcon="label"></mat-icon>
                    {{'events.metrics' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row">

                <ul class="metric-status-list">
                    @for(metric of row.metrics; track metric.trackerName) {
                    <li class="metric-status {{metric.color}}">
                        <b>{{metric.name}} - </b>
                        <span>{{metric.trackerName}}</span><br>
                        <span>{{metric.color}}</span>
                        <span>{{metric.createdDate}}</span>
                    </li>
                    }
                </ul>
            </td>
        </ng-container>
        <ng-container matColumnDef="attachments">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="header-content">
                    <mat-icon fontIcon="picture"></mat-icon>
                    {{'units.picture' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row">

                <div class="att-status-list">
                    @for(att of row.attachments; track att.trackerName) {
                    <div class="att-status {{att.color}}" [style.backgroundImage]="'url(' + att.url + ')'">
                        <div class="att-status-info">
                            <span>{{att.trackerName}}</span>
                            <span>{{att.createdDate}}</span>
                        </div>
                        <!-- <img src="{{att.url}}" width="100px" height="70px"> -->

                    </div>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="header-content">
                    <mat-icon fontIcon="calendar_today"></mat-icon>
                    {{'datatable.endDate' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row">
                {{row.endDate | timeFormat:'yyyy/MM/dd'}}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <div class="header-content">
                    <mat-icon fontIcon="edit"></mat-icon>
                    {{'form.action' | translate}}
                </div>
            </th>

            <td mat-cell *matCellDef="let row">


            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="projectsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: projectsColumns;"></tr>

        <tr class="mat-row no-data-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="projectsColumns.length">
                <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                </lib-no-data>
            </td>
        </tr>
    </table>


    <mat-paginator #projectPaginator [length]="projectsCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
        class="paginator" (page)="handlePageEvent($event)">
    </mat-paginator>

    <div *ngIf="loading" class="table-overlay">
        <app-spinner></app-spinner>
    </div>
</div>